/* globals PhotoSwipe, PhotoSwipeUI_Default */

const PSWP_IMG = 'photoswipe__image';

function getGalleryItems(container) {
  const imgs = container.querySelectorAll(`.${PSWP_IMG}`);
  return Array.from(imgs).map((img) => {
    const { dataset } = img;

    const props = {
      msrc: img.src,
      src: dataset.photoswipeSrc,
      w: dataset.photoswipeWidth,
      h: dataset.photoswipeHeight,
      el: img,
      initialZoomLevel: 0.5,
    };

    if (img.parentElement.nodeName === 'A' && img.parentElement.title) {
      props.title = img.parentElement.title;
    } else if (img.title) {
      props.title = img.title;
    }

    return props;
  });
}

function openPswp(items, index) {
  const pswpElement = document.querySelectorAll('.pswp')[0];
  const options = {
    allowPanToNext: false,
    barsSize: { top: 10, bottom: 152 },
    captionEl: true,
    closeOnScroll: false,
    counterEl: false,
    history: false,
    index,
    pinchToClose: false,
    preloaderEl: false,
    scaleMode: 'fit',
    shareEl: false,
    showHideOpacity: true,
    tapToToggleControls: false,
    getThumbBoundsFn: function (index) {
      const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
      const thumbnail = items[index].el;
      const rect = thumbnail.getBoundingClientRect();
      return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
    },
  };

  const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
}

export const initPhotoswipe = () => {
  const mediaGrids = document.querySelectorAll('.lg-pswp-gallery');
  mediaGrids.forEach((mediaGrid) => {
    mediaGrid.addEventListener('click', (evt) => {
      evt.preventDefault();
      const container = evt.currentTarget;
      const target = evt.target;

      if (target.classList.contains(PSWP_IMG)) {
        const index = parseInt(target.getAttribute('data-index'), 10);
        openPswp(getGalleryItems(container), index);
      }
    });
  });
};
